import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const PaymentCancel = () => (
  <div data-testid="payment-cancel-page" className="bg-ivory min-h-[70vh]">
    <section className="mx-auto max-w-3xl px-6 sm:px-12 py-28 text-center">
      <Reveal>
        <p className="eyebrow">Checkout Paused</p>
        <h1 className="mt-5 font-serif text-4xl sm:text-5xl font-light tracking-tight">Your candles are still waiting.</h1>
        <p className="mx-auto mt-6 max-w-md text-sm md:text-base text-stone2 leading-relaxed">
          Nothing was charged. Your bag has been saved — come back whenever you're ready.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/cart" data-testid="cancel-return-cart" className="btn-primary">Return to Cart</Link>
          <Link to="/shop" data-testid="cancel-continue-shopping" className="btn-outline">Continue Shopping</Link>
        </div>
      </Reveal>
    </section>
  </div>
);

export default PaymentCancel;
